﻿import TKDialog from '@tk/components/tk.dialog';
import { fetchRequest } from '@tk/utilities/tk.fetch';

export default class KDMZDialog extends TKDialog {
    web2print: boolean;
    shouldFullTop: boolean;
    fullTopClassName: string;
    breakpointClassName: string;
    dialog?: HTMLElement;
    web2printAmountField?: HTMLInputElement;
    web2printAmount?: string;

    constructor() {
        super();
        this.web2print = this.hasAttribute('data-web2print-dialog');
        this.shouldFullTop = this.hasAttribute('data-tk-should-full-top');
        this.fullTopClassName = this.getAttribute('data-tk-full-top-class-name') || 'tk-dialog--full-top';
        this.breakpointClassName = this.getAttribute('data-tk-breakpoint-class-name') || '';
    }

    createDialog(url: string): HTMLDialogElement {
        const dialog = TKDialog.renderDialog({
            className: `${this.dialogClassName} ${this.shouldMaxWidth ? this.maxWidthClassName : ''} ${this.shouldFullTop ? this.fullTopClassName : ''} ${this.breakpointClassName ? this.breakpointClassName : ''}`,
            closeClassName: this.dialogCloseClassName,
            innerClassName: this.dialogInnerClassName,
            tag: this.tag,
            isConfirm: this.isConfirm,
            confirmURL: url,
            confirmTitle: this.confirmTitle,
            confirmDescription: this.confirmDescription,
            confirmCancelIcon: this.confirmCancelIcon,
            confirmCancelLabel: this.confirmCancelLabel,
            confirmSubmitIcon: this.confirmSubmitIcon,
            confirmSubmitLabel: this.confirmSubmitLabel,
        });
        const onClosed = this.closedDialog.bind(this);
        this.pushListener({ event: 'close', element: dialog, action: onClosed });
        this.currentDialog = this.dialogs.push({ url, dialog }) - 1;
        return dialog;
    }

    handleResponseSuccess(url: string, response: TKResponse): void {
        if (!response || !response.success) return;
        this.closeCurrentDialog();
        const dialog = this.createDialog(url);
        const content = dialog.querySelector('[data-tk-dialog-content]');
        if (!content) return;
        content.innerHTML = response.dataAsHtml;
        TKDialog.open(dialog, this.isPopup);
        this.hookAfterShowModal(dialog);
        const form = content.querySelector('form');
        form && this.registerFormListener(form);
        this.dialog = dialog;
        if (this.web2print) {
            this.handleIframe();
        }
    }

    handleIframe() {
        const iframe = this.dialog!.querySelector('iframe');
        iframe!.contentWindow!.parent.parent.addEventListener('message', (e) => {
            const json = JSON.parse(e.data.arr);
            const data = {
                postit_json: JSON.stringify(json.data),
                postit_pdf: json.pdf,
                postit_jpg: json.jpg,
                postit_name: json.name,
                postit_valid: json.valid,
                postit_quantity: json.quantity,
            };
            const setDataURLElement = document.querySelector('#web2print-setdata-url');

            if (setDataURLElement) {
                const setDataURL = setDataURLElement.getAttribute('data-url');

                fetchRequest({
                    requestURL: setDataURL!,
                    payload: data,
                    resolveHandler: this.iframeSave.bind(this),
                });
            }
        });
    }

    iframeSave() {
        const setDataURLElement = document.querySelector('#web2print-setdata-url');
        if (setDataURLElement) {
            const redirectURL = setDataURLElement.getAttribute('data-redirect-url');
            window.location = redirectURL;
        } else {
            window.location.reload();
        }
    }

    hookAfterShowModal(dialog: HTMLDialogElement): void {
        TKDialog.attachButtonClickHandler(dialog, '[data-tk-dialog-close]', () =>
            TKDialog.close(dialog, this.forceReloadContent),
        );
        TKDialog.attachButtonClickHandler(dialog, '[data-tk-dialog-close-and-reset]', (button) =>
            this.handleActions(DialogActions.RESET_FORM, button),
        );
        TKDialog.attachButtonClickHandler(dialog, '[data-tk-dialog-jump-forward]', (button) =>
            this.handleActions(DialogActions.JUMP_FORWARD, button),
        );
        TKDialog.attachButtonClickHandler(dialog, '[data-tk-dialog-jump-backward]', (button) =>
            this.handleActions(DialogActions.JUMP_BACKWARD, button),
        );
        TKDialog.attachButtonClickHandler(dialog, '[data-tk-dialog-jump-to]', (button) =>
            this.handleActions(DialogActions.JUMP_TO, button),
        );

        if (this.web2print) {
            const detailBody = this.closest('.module-article__detail-body');
            if (detailBody) {
                this.web2printAmountField = detailBody!.querySelector('#field1') as HTMLInputElement;
                this.web2printAmount = this.web2printAmountField.value;
                const iframe = dialog.querySelector('iframe');
                if (iframe) {
                    const iframeURL = new URL(iframe.src);
                    iframeURL.searchParams.set('quantity', this.web2printAmount!);
                    iframe.src = iframeURL.toString();
                }
            }
        }
    }
}
